// actions/index.js

export const SET_USER_UID = "SET_USER_UID";

/**
 * Action creator to set the authenticated user's UID in the Redux store.
 * This should be dispatched after a successful login or when the app
 * detects an authenticated user on initialization.
 *
 * @param {string} uid - The unique identifier of the authenticated user from Firebase Auth.
 * @returns {Object} Redux action with type SET_USER_UID and the UID as payload
 */
export const setUserUid = (uid) => ({
  type: SET_USER_UID,
  payload: uid,
});
